import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../_models/app-config';
import { firstValueFrom } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
  
    private appConfig: AppConfig = {} as AppConfig;

    constructor(private http: HttpClient) {

    }

    loadConfig(configName: string = "app") {
        return firstValueFrom(this.http.get<AppConfig>(`./assets/config/${configName}.json`))
        .then((data) => {
            this.appConfig = data;
        })
    }

    get config(): Readonly<AppConfig> {
        return this.appConfig;
    }
}